import { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import Icons from '../../../../../../components/Common/Icons/Icons';
import ScanDetailsDialog from './JobDetails/Modals/ScanDetails';
import Checkbox from '../../../../../../components/Common/UI/Checkbox';
import { Badge } from '../../../../../../components/Common/UI/Badge';
import { JobDetailRowType } from './JobDetails/jobDetailsData';
import { DeliveryInfoRowArr, DeliveryInfoRowType } from './DeliveryInfo/deliveryInfoData';
import { PdfViewerTrigger } from '../../../../../../context/pdfViewerDialog';

/** Job detail */
export type JobDetailColumnType = 'total' | 'posted' | 'failed' | 'presort' | 'firstClass' | 'nonMail' | 'nonPrint';
export enum JobDetailColumnEnum {
  total = 'Total',
  posted = 'Posted',
  failed = 'Failed',
  presort = 'Presort',
  firstClass = 'First Class',
  nonMail = 'Non-Mail',
  nonPrint = 'Non-Print',
}
/** Delivery info */
export type DeliveryInfoColumnType = 'percentage'; // 'complete'
/** Geo Delivery Data */
export type GeoDeliveryColumnType = 'totalMail' | 'deliveredMail' | 'scannableMail' | 'exceptionMail';
export enum GeoDeliveryColumnEnum {
  totalMail = 'Total Mail',
  deliveredMail = 'Delivered Mail',
  scannableMail = 'Scannable Mail',
  exceptionMail = 'Exception Mail',
}

export interface JobSubTableAccount {
  id: string;
  accountNumber: number;
  accountName: string;
  accountType: string;
  jobType: JobDetailColumnType;
  emailsSent?: number | null;
  // Posted /\
  grouped?: string;
  IMB?: string;
  address?: string;
  state?: string;
  days?: string;
  delivery?: string | 'Transit' | 'Exception Mail' | 'Delivered Mail' | 'Scannable Mail';
  status?: string | 'Delivered' | 'Pending';
  geoDeliveryStatus?: 'delivered' | 'scannable' | 'exception';
  insert?: string;
  divert?: 'checkbox' | string;
  // Inserts
  insertName?: string;
  count?: number;
}
export interface ProofingSample {
  id: string;
  nameSample: string;
}

/** Data */
export const jobSubTableAccountsData: JobSubTableAccount[] = [
  {
    id: '1111111',
    accountNumber: 10087015,
    accountName: 'LOUISE F CLARKE, TRUSTEE',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '22222222',
    accountNumber: 10027295,
    accountName: 'ELBERT E SEAL',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '3333333',
    accountNumber: 10759386,
    accountName: 'DEBRA M SHULTZ, TRUSTEE',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '4444444',
    accountNumber: 10144325,
    accountName: 'LAWRENCE B FERNANDEZ',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '5555555',
    accountNumber: 11112424,
    accountName: 'ELAINE R WOLFE, TRUSTOR',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '6666666',
    accountNumber: 11353271,
    accountName: 'JUNE ALEMAN',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '7777777',
    accountNumber: 12353265,
    accountName: 'RUBY JANE DUENSING',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '8888888',
    accountNumber: 14447546,
    accountName: 'HENRY H WILLIAMS',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '9999999',
    accountNumber: 10000251,
    accountName: 'JANET L CONANT',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '1000000',
    accountNumber: 10085781,
    accountName: 'SHARON JACKSON',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '1-11111',
    accountNumber: 109988774,
    accountName: 'JUDIT L HODGKINGSON, TRUSTEE',
    accountType: '',
    jobType: 'posted',
    emailsSent: null,
  },
  {
    id: '2-22222',
    accountNumber: 10568,
    accountName: 'KATHRYN MARTUCCI',
    accountType: '',
    grouped: '',
    jobType: 'nonPrint',
    IMB: '000734575752065752371',
    address: 'KATHRYN MARTUCCI,,61 WESTCHESTER DRIVE CLIFTON PARK, NY 12065',
    state: 'ny',
  },
  {
    id: '3-3333333',
    accountNumber: 1028,
    accountName: 'KATHRYN MORIARTI',
    accountType: '',
    grouped: '',
    jobType: 'firstClass',
    IMB: '000874630001120652371',
    address: 'KATHRYN MORIARTI,,71 WESTCHESTER DRIVE CLIFTON PARK, NY 12065',
    state: 'ny',
    days: '2',
    delivery: 'Exception Mail',
    geoDeliveryStatus: 'exception',
  },
  {
    id: '4-4444444',
    accountNumber: 1021258,
    accountName: 'LUKE SCHLOTTERBECK',
    accountType: '',
    grouped: '',
    jobType: 'presort',
    IMB: '000375473457120672371',
    address: 'LUKE SCHLOTTERBECK,, 6396 BADGER LAKE AVENUE SAN DIEGO, CA 92119',
    state: 'ca',
    delivery: 'Transit',
    status: 'Delivered',
    divert: 'checkbox',
  },
  {
    id: '5-555555',
    accountNumber: 1021259,
    accountName: 'LUKE SKYWALKER',
    accountType: '',
    grouped: '',
    jobType: 'presort',
    IMB: '000775463445128672312',
    address: 'LUKE SKYWALKER,, 6393 BADGER LAKE AVENUE SAN DIEGO, CA 92119',
    state: 'ca',
    days: '6',
    delivery: 'Transit',
    divert: 'checkbox',
  },
  {
    id: '7-7777777',
    accountNumber: 1065828,
    accountName: 'MARK RONSON',
    accountType: '',
    grouped: '',
    jobType: 'presort',
    IMB: '000132498756401122322',
    address: 'MARK RONSON, RICARDO ALVARADO,1768 GENTLE CURRENT WAY, SAN DIEGO, CA 92151 SAN DIEGO, CA 92119',
    state: 'ca',
    days: '5',
    status: 'Delivered',
    delivery: 'Delivered Mail',
    geoDeliveryStatus: 'delivered',
  },
  {
    id: '6-6666',
    accountNumber: 1065828,
    accountName: 'JASON STATHAM',
    accountType: '',
    grouped: '',
    jobType: 'presort',
    IMB: '000734573573001122371',
    address: 'JASON STATHAM,,5150 CALLE SANDWAVES UNIT 33 SAN DIEGO, CA 92151',
    state: 'ca',
    days: '4',
    status: 'Delivered',
    delivery: 'Delivered Mail',
    geoDeliveryStatus: 'delivered',
  },
  {
    id: '8-88888',
    accountNumber: 1065828,
    accountName: 'JULIETTE A PARKER',
    accountType: '',
    grouped: '',
    jobType: 'presort',
    IMB: '00532498753901128875',
    address: 'JULIETTE A PARKER, PO BOX 211333, CHULA VISTA, CA 91921-1333 CHULA VISTA, CA 91910',
    state: 'ca',
    days: '5',
    delivery: 'Scannable Mail',
    geoDeliveryStatus: 'scannable',
  },
  {
    id: '9-99999',
    accountNumber: 1065828,
    accountName: 'MATHEW BRONSON',
    accountType: '',
    grouped: '',
    jobType: 'firstClass',
    IMB: '0007345757750112065371',
    address: 'MATHEW BRONSON,,415 LILLY DRD APTA, COMMERCE TX 7528',
    state: 'tx',
    delivery: 'Scannable Mail',
    geoDeliveryStatus: 'scannable',
  },
  {
    id: '999-9679797979',
    accountNumber: 9991,
    accountName: 'JARAD HIGGINS',
    accountType: '',
    grouped: '',
    jobType: 'firstClass',
    IMB: '000874630201420752999',
    address: 'JARAD HIGGINS,,70 WESTCHESTER DRIVE CLIFTON PARK, NY 12065',
    state: 'ny',
    delivery: 'Delivered Mail',
    geoDeliveryStatus: 'delivered',
    status: 'Pending',
  },
  {
    id: '123-12375479',
    accountNumber: 9992,
    accountName: 'NATALIE DEPP',
    accountType: '',
    grouped: '',
    jobType: 'firstClass',
    IMB: '000977830801820782988',
    address: 'NATALIE DEPP,,70 WESTCHESTER DRIVE CLIFTON PARK, NY 12065',
    state: 'ny',
    delivery: 'Delivered Mail',
    geoDeliveryStatus: 'delivered',
    status: 'Pending',
  },
  {
    id: '10-10000000',
    jobType: 'total',
    insert: '33310',
    insertName: 'MASTERCARD EASY SAVING [ACCOUNT LIST]',
    count: 1,
    accountType: '',
    accountName: 'inserts', // inserts data should have accountName: 'inserts'!
    accountNumber: 124,
  },
];

export const proofingSampleData: ProofingSample[] = [
  {
    id: '123454321',
    nameSample: 'John',
  },
  {
    id: '103454311',
    nameSample: 'Nick',
  },
];

/** Configuration for sub-table Job-Details tab */

export function DownloadPdfLink() {
  return (
    <PdfViewerTrigger src="/infoTrac/jobDetails/statement.pdf">
      <a href="#" onClick={e => e.preventDefault()} aria-label="download-pdf">
        <Icons.PDF className="text-primary-text" />
      </a>
    </PdfViewerTrigger>
  );
}

export const jobTypesElectronic: JobDetailColumnType[] = ['posted', 'failed'];
export const jobTypesPaper: JobDetailColumnType[] = ['presort', 'firstClass', 'nonMail', 'nonPrint'];

export const filterDataColumnsByJobType = (jobColumnsType: 'Electronic' | 'Paper', data: JobSubTableAccount[]) =>
  data.filter(item =>
    jobColumnsType === 'Electronic' ? jobTypesElectronic.includes(item.jobType) : jobTypesPaper.includes(item.jobType)
  );

// this type should be same as JobDetailColumnType
// export type JobTypeAccount = 'total' | 'posted' | 'nonPrint' | 'presort' | string;

/** Columns config for columns for 'Posted' type from 'Electronic' */
export const jobSubTableElectronicColumns: ColumnDef<JobSubTableAccount>[] = [
  {
    accessorKey: 'accountNumber',
    header: 'Account Number',
    enableSorting: true,
  },
  {
    accessorKey: 'accountName',
    header: 'Account Name',
    enableSorting: true,
  },
  {
    accessorKey: 'accountType',
    header: 'Account Type',
    enableSorting: true,
  },
  {
    accessorKey: 'jobType',
    header: 'Job Type',
    cell: ({ row }) => JobDetailColumnEnum[row.original.jobType],
    enableSorting: true,
  },
  {
    accessorKey: 'emailsSent',
    header: 'Email(s) Sent',
    enableSorting: true,
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: () => <DownloadPdfLink />,
    size: 50,
  },
];

export const jobSubTablePaperColumns: ColumnDef<JobSubTableAccount>[] = [
  {
    accessorKey: 'accountNumber',
    header: 'Account Number',
    enableSorting: true,
  },
  {
    accessorKey: 'accountName',
    header: 'Account Name',
    enableSorting: true,
  },
  {
    accessorKey: 'accountType',
    header: 'Account Type',
    enableSorting: true,
  },
  {
    accessorKey: 'jobType',
    header: 'Job Type',
    cell: ({ row }) => JobDetailColumnEnum[row.original.jobType],
    enableSorting: true,
  },
  {
    accessorKey: 'grouped',
    header: 'Grouped',
    enableSorting: true,
  },
  {
    accessorKey: 'IMB',
    header: 'IMB',
    enableSorting: true,
  },
  {
    accessorKey: 'address',
    header: 'Address',
  },
  {
    accessorKey: 'days',
    header: 'Days',
    enableSorting: true,
  },
  {
    accessorKey: 'delivery',
    header: 'Delivery',
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    enableSorting: true,
  },
  {
    accessorKey: 'insert',
    header: 'Insert',
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => (
      <div className="flex gap-2 items-center text-primary">
        {row.original.jobType === 'presort' ? (
          <>
            <ScanDetailsDialog variant="truck" status={row.original.status} userData={row.original} />
            <DownloadPdfLink />
            {/* <ScanDetailsDialog variant="camera" status={row.original.status} userData={row.original} /> */}
          </>
        ) : null}
        {row.original.jobType === 'firstClass' ? (
          <>
            <DownloadPdfLink />
            {/* <ScanDetailsDialog variant="camera" status={row.original.status} userData={row.original} /> */}
          </>
        ) : null}
      </div>
    ),
    size: 50,
  },
  {
    id: 'divert',
    accessorKey: 'divert',
    header: 'Divert',
    cell: ({ row }) => {
      const val = row.getValue('divert');

      if (val === 'checkbox') {
        return <Checkbox />;
      }

      return val;
    },
  },
];

export const jobDetailColInserts: ColumnDef<JobSubTableAccount>[] = [
  {
    accessorKey: 'insert',
    header: 'Insert',
    enableSorting: true,
  },
  {
    accessorKey: 'insertName',
    header: 'Insert Name',
    enableSorting: true,
  },
  {
    accessorKey: 'count',
    header: 'Count',
    enableSorting: true,
    cell: ({ row }) => <Badge variant="counter">{row.getValue('count')}</Badge>,
  },
];
export const proofingSampleColumns: ColumnDef<ProofingSample>[] = [
  {
    accessorKey: 'nameSample',
    header: 'Name',
    enableSorting: false,
    size: 250,
  },
  {
    id: 'actions',
    header: 'STATEMENT SAMPLE',
    enableSorting: false,
    cell: () => <DownloadPdfLink />,
  },
];

export const getSubTableColConfig = (
  id: string,
  tableRowType: JobDetailRowType | DeliveryInfoRowType | null | string,
  noActionsTable?: boolean,
  hideDivertCheckboxes?: boolean
) => {
  if (tableRowType === 'INSERTS') {
    return jobDetailColInserts;
  }

  /** If row type from delivery info, then show same columns as on Paper details, but without divert col */
  if (noActionsTable || DeliveryInfoRowArr.includes(tableRowType as DeliveryInfoRowType)) {
    return jobSubTablePaperColumns.filter(item => item.id !== 'divert');
  }

  // If row type === 'ACCOUNTS'
  if (id === 'Electronic') {
    // && (tableRowType === 'ACCOUNTS' || tableRowType === '')
    return jobSubTableElectronicColumns;
  }

  if (hideDivertCheckboxes) {
    return jobSubTablePaperColumns.map(column => {
      if (column.id !== 'divert') {
        return column;
      }

      const divertColumn: ColumnDef<JobSubTableAccount> = {
        ...column,
        cell: ({ row }) => {
          const val = row.getValue('divert');

          return val === 'checkbox' ? null : val;
        },
      };

      return divertColumn;
    });
  }

  // if (id === 'Paper') { || any of DeliveryInfoRowType have same layout as Paper.
  return jobSubTablePaperColumns;
};
